var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{pre:true,attrs:{"fill":"none","d":"M0 0h24v24H0z"}}),_c('path',{pre:true,attrs:{"d":"M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10m1-17.93c3.94.49 7 3.85 7 7.93s-3.05 7.44-7 7.93z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }